import { normalizeText } from './normalize';

declare global {
  interface String {
    trimRight(string: string): string;
    hashCode(): number;
  }
  interface Date {
    diffInMinutes(compareWith: Date): number;
    toDateWithOutTimeZone(date: string): Date;
    addDays(days: number): Date;
  }
}

Date.prototype.diffInMinutes = function(compareWith: Date): number {
  let diff = (compareWith.getTime() - this.getTime()) / 1000;
  diff /= 60;

  return Math.round(diff);
};

String.prototype.normalize = function (): string {
  return normalizeText(this);
};

String.prototype.trimRight = function(): string {
  return this.replace(/\s+$/, '');
};

String.prototype.hashCode = function(): number {
  let h = 0;
  const l = this.length;
  let i = 0;
  if ( l > 0 ) {
    while (i < l) {
      h = (h << 5) - h + this.charCodeAt(i++) | 0;
    }
  }
  return Math.abs(h);
};

Date.prototype.addDays = function(days: number): Date {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);

  return date;
};
